// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 600px) {
  /* General resets for small screens */
  body {
    padding: 0 8px; /* Small horizontal padding */
    overflow-x: hidden; /* Prevent horizontal scroll */
  }

  /* Make most block elements take the full available width */
  button,
  select,
  input,
  textarea,
  .column-dropdowns,
  .search-column-button,
  .selected-column-display,
  .select-column-button,
  #illnessColumnDropdown,
  #sampleColumnDropdown,
  .info-message-step3 {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  /* Stack flex rows into columns for narrow screens */
  .sample-column-section,
  .dropdowns-row,
  .column-selection-area {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
  }

  /* Tables and graphs should be scrollable if they overflow */
  table,
  .table-responsive {
    display: block;
    overflow-x: auto;
    width: 100%;
  }

  /* Images and canvases should never exceed the viewport */
  img,
  canvas {
    max-width: 100%;
    height: auto;
  }
  /* Add extra spacing below main content for mobile */
  .main-content {
    margin-bottom: 24px;
  }
} `, "",{"version":3,"sources":["webpack://./src/css/responsive.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC;IACE,cAAc,EAAE,6BAA6B;IAC7C,kBAAkB,EAAE,8BAA8B;EACpD;;EAEA,2DAA2D;EAC3D;;;;;;;;;;;IAWE,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA,oDAAoD;EACpD;;;IAGE,iCAAiC;IACjC,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA,4DAA4D;EAC5D;;IAEE,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;EAEA,yDAAyD;EACzD;;IAEE,eAAe;IACf,YAAY;EACd;EACA,oDAAoD;EACpD;IACE,mBAAmB;EACrB;AACF","sourcesContent":["@media (max-width: 600px) {\n  /* General resets for small screens */\n  body {\n    padding: 0 8px; /* Small horizontal padding */\n    overflow-x: hidden; /* Prevent horizontal scroll */\n  }\n\n  /* Make most block elements take the full available width */\n  button,\n  select,\n  input,\n  textarea,\n  .column-dropdowns,\n  .search-column-button,\n  .selected-column-display,\n  .select-column-button,\n  #illnessColumnDropdown,\n  #sampleColumnDropdown,\n  .info-message-step3 {\n    width: 100% !important;\n    max-width: 100% !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  /* Stack flex rows into columns for narrow screens */\n  .sample-column-section,\n  .dropdowns-row,\n  .column-selection-area {\n    flex-direction: column !important;\n    align-items: stretch !important;\n    gap: 12px !important;\n  }\n\n  /* Tables and graphs should be scrollable if they overflow */\n  table,\n  .table-responsive {\n    display: block;\n    overflow-x: auto;\n    width: 100%;\n  }\n\n  /* Images and canvases should never exceed the viewport */\n  img,\n  canvas {\n    max-width: 100%;\n    height: auto;\n  }\n  /* Add extra spacing below main content for mobile */\n  .main-content {\n    margin-bottom: 24px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
